export const walletButtonStyle = `
        body {
            --radix-connect-button-width: 0px;
            --radix-connect-button-height: 38px;
            --radix-connect-button-border-radius: 24px;
        }
    `
    ;

export const walletButtonBoxStyle = {
    mt: "1",
    ml: "5",
    mr: "5",
};